import React, { useEffect, useState } from 'react';
import { AwardIcon } from 'lucide-react';
export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0F1115]/90 backdrop-blur-md border-b border-gray-800' : 'bg-transparent'}`} data-id="element-60">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-61">
        <div className="flex items-center justify-between h-20" data-id="element-62">
          {/* Logo */}
          <div className="flex items-center cursor-default" data-id="element-63">
            <img src="https://cdn.magicpatterns.com/uploads/xoV8WdVtYH8fbNCxUxVcda/2.png" alt="CertifiedDevs" className="h-24 w-auto" data-id="element-64" />
          </div>
        </div>
      </div>
    </header>;
};